import { DefaultPageLayout } from 'components/site/layouts/DefaultPageLayout';
import { ResellerPageContent } from 'components/site/pages/ResellerPageContent';
import CSS from 'csstype';

export interface IProps {
    style?: CSS.Properties;
    className?: string;
}

export const ResellerPage = (): JSX.Element => {
    return (
        <DefaultPageLayout forceLogin={true} title="Manage users.">
            <ResellerPageContent />
        </DefaultPageLayout>
    );
};
